import { Seo } from "../components/site/Seo";
import { Eyebrow } from "../components/site/Reveal";
import { CONTACT } from "../lib/site";

const S = ({ title, children }) => (
  <section className="border-t border-forest/10 py-8">
    <h2 className="font-display text-2xl font-medium tracking-tight text-forest">{title}</h2>
    <div className="mt-4 space-y-3 leading-relaxed text-ink/80">{children}</div>
  </section>
);

export default function PrivacidadePage() {
  return (
    <>
      <Seo title="Política de Privacidade | Mega Solar" path="/politica-de-privacidade"
        description="Informação sobre o tratamento de dados pessoais recolhidos através do website da Mega Solar, nos termos do RGPD." />
      <article data-testid="privacy-page" className="bg-paper pt-32 pb-24 sm:pt-40">
        <div className="container-x max-w-3xl">
          <Eyebrow>Documento para revisão</Eyebrow>
          <h1 className="mt-6 font-display text-4xl font-semibold tracking-tight text-forest sm:text-5xl lg:text-6xl">Política de Privacidade</h1>
          <p className="mt-6 rounded-2xl border border-gold bg-gold/10 p-4 text-sm text-ink/85">
            Versão preliminar, a rever pela Mega Solar (e, idealmente, por um jurista) antes da publicação. Os campos entre parênteses retos devem ser completados.
          </p>
          <S title="1. Responsável pelo tratamento">
            <p>Mega Solar — [denominação social completa], NIPC 517433907, com sede em [morada a indicar]. Contacto: <a className="text-forest underline" href={CONTACT.emailHref}>{CONTACT.email}</a> · <a className="text-forest underline" href={CONTACT.phoneHref}>{CONTACT.phoneDisplay}</a>.</p>
          </S>
          <S title="2. Dados recolhidos">
            <p>Através do formulário de pedido de orçamento recolhemos: nome, e-mail, telefone, código postal e localidade, tipo de cliente, tipo de instalação pretendida e, opcionalmente, consumo ou valor da fatura, tipo de habitação ou telhado, nome e atividade da empresa, área disponível e informação adicional que decida partilhar.</p>
            <p>Recolhemos apenas os dados necessários para analisar o pedido e preparar uma proposta.</p>
          </S>
          <S title="3. Finalidade e fundamento">
            <p>Os dados são tratados para responder ao seu pedido de orçamento ou contacto e, se for o caso, preparar uma proposta comercial (diligências pré-contratuais a pedido do titular — art.º 6.º, n.º 1, al. b) do RGPD), com base no consentimento que presta no formulário.</p>
            <p>Não utilizamos os dados para envio de comunicações de marketing sem o seu consentimento específico.</p>
          </S>
          <S title="4. Conservação">
            <p>Os dados são conservados pelo período necessário à resposta ao pedido e ao eventual acompanhamento comercial, por um prazo máximo de 24 meses sem nova interação, sendo depois eliminados, salvo obrigação legal de conservação.</p>
          </S>
          <S title="5. Destinatários e subcontratantes">
            <p>Os dados são armazenados na infraestrutura de alojamento do website e enviados por e-mail à equipa Mega Solar através de um serviço de envio de e-mail transacional, que é também utilizado para enviar ao requerente um e-mail de confirmação da receção do pedido. Estes prestadores atuam como subcontratantes. [Identificar prestadores e eventuais transferências para fora do Espaço Económico Europeu.]</p>
          </S>
          <S title="6. Direitos do titular">
            <p>Pode solicitar o acesso, a retificação, o apagamento, a limitação ou a portabilidade dos seus dados, opor-se ao tratamento e retirar o consentimento a qualquer momento, através de <a className="text-forest underline" href={CONTACT.emailHref}>{CONTACT.email}</a>.</p>
            <p>Tem ainda o direito de apresentar reclamação à Comissão Nacional de Proteção de Dados (CNPD).</p>
          </S>
          <S title="7. Segurança">
            <p>Os formulários são transmitidos por ligação cifrada (HTTPS) e o acesso aos pedidos está restrito a utilizadores autorizados. Aplicamos medidas contra envios automáticos (spam).</p>
          </S>
          <S title="8. Cookies">
            <p>O website da Mega Solar não utiliza cookies de publicidade. Caso venham a ser utilizadas ferramentas de análise ou cookies não essenciais, será apresentado previamente um mecanismo de gestão de consentimento. [Rever após configuração final das ferramentas de análise.]</p>
          </S>
          <p className="mt-8 text-sm text-ink/65">Última atualização: [data a indicar na publicação].</p>
        </div>
      </article>
    </>
  );
}
